import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/static/icons/ranking/gold-medal.svg'
import _imports_1 from '../../../assets/static/icons/ranking/silver-medal.svg'
import _imports_2 from '../../../assets/static/icons/ranking/bronze-medal.svg'


const _withScopeId = n => (_pushScopeId("data-v-33db6336"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ranking-statistics" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Ranking de usuários", -1))
const _hoisted_3 = { class: "user__image-container" }
const _hoisted_4 = {
  key: 0,
  class: "user__image__medal",
  width: "30",
  height: "30",
  src: _imports_0,
  alt: ""
}
const _hoisted_5 = {
  key: 1,
  class: "user__image__medal",
  width: "30",
  height: "30",
  src: _imports_1,
  alt: ""
}
const _hoisted_6 = {
  key: 2,
  class: "user__image__medal",
  width: "30",
  height: "30",
  src: _imports_2,
  alt: ""
}
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "wrap" }
const _hoisted_9 = { class: "user__names" }
const _hoisted_10 = { class: "user__name" }
const _hoisted_11 = {
  key: 0,
  class: "user__company"
}
const _hoisted_12 = { class: "user__content-duration" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("ul", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.usersRanking, (user, index) => {
        return (_openBlock(), _createElementBlock("li", {
          class: "user",
          key: index
        }, [
          _createElementVNode("div", _hoisted_3, [
            (index === 0)
              ? (_openBlock(), _createElementBlock("img", _hoisted_4))
              : _createCommentVNode("", true),
            (index === 1)
              ? (_openBlock(), _createElementBlock("img", _hoisted_5))
              : _createCommentVNode("", true),
            (index === 2)
              ? (_openBlock(), _createElementBlock("img", _hoisted_6))
              : _createCommentVNode("", true),
            _createElementVNode("img", {
              width: "50",
              height: "50",
              src: user.image,
              onError: _cache[0] || (_cache[0] = 
              event =>
                (event.target.src = require('../../../assets/static/icons/onerror-user.png'))
            ),
              alt: "",
              class: _normalizeClass([
              'user__image',
              { gold: index === 0, silver: index === 1, bronze: index === 3 }
            ])
            }, null, 42, _hoisted_7)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("span", _hoisted_10, _toDisplayString(user.name), 1),
              (user.companies)
                ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(user.companies[0].name), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.formattedDuration(user.contentDuration)), 1)
          ])
        ]))
      }), 128))
    ])
  ]))
}